import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/custom_list_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  code_cont: {
    model_name: 'CustomList',
    column_type: 'string',
    column_name: 'code',
  },
  name_cont: {
    model_name: 'CustomList',
    column_type: 'string',
    column_name: 'name',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'CustomList',
      options: ['merchant_list', 'list_with_image', 'video_list', 'image'],
    },
    model_name: 'CustomList',
    column_name: 'kind',
  },
  kind_not_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'CustomList',
      options: ['merchant_list', 'list_with_image', 'video_list', 'image'],
    },
    model_name: 'CustomList',
    column_name: 'kind',
  },
  is_active_eq: {
    column_type: 'boolean',
    model_name: 'CustomList',
    column_name: 'isActive',
  },
}
export const formColumnsConfig = {
  'self': {
    'code': { required: true, disabledUpdate: false },
    'name': { required: true, disabledUpdate: false },
    'kind': { required: true, disabledUpdate: false },
    'is_active': { required: false, disabledUpdate: false },
    'merchant_ids': { required: false, disabledUpdate: false },
    'custom_list_items_attributes': { required: false, disabledUpdate: false },
  },
  'custom_list_items_attributes': {
    'id': { required: false, disabledUpdate: true },
    'target_type': { required: false, disabledUpdate: true },
    'target_id': { required: false, disabledUpdate: true },
    'external_link': { required: false, disabledUpdate: true },
    'position': { required: false, disabledUpdate: true },
    'image': { required: false, disabledUpdate: true },
    'video': { required: false, disabledUpdate: true },
    'video_cover': { required: false, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('CustomList', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('CustomList', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
